<div class="d-grid h-100" style="grid-template-rows: auto 1fr auto">
  <div class="modal-header border-2 border-primary modal-header pt-2">
    <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="activeTab">
      <li ngbNavItem="find">
        <button ngbNavLink="find">Find</button>
      </li>
      <li ngbNavItem="replace">
        <button ngbNavLink="replace">Replace</button>
        <ng-template ngbNavContent>
          <div class="form-group">
            <label for="replaceWith">Replace with:</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              id="replaceWith"
              (change)="onReplaceWhatChanged($event)" />
          </div>
        </ng-template>
      </li>
    </ul>
  </div>
  <div class="modal-body container py-2 overflow-auto">
    <div class="form-group">
      <label for="findWhat">Find what:</label>
      <input
        ngbAutofocus
        type="text"
        class="form-control"
        id="findWhat"
        autocomplete="off"
        [(ngModel)]="searchQuery"
        (change)="onFindWhatChanged($event)" />
    </div>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
    <hr />
    <div class="d-grid gap-2 d-grid-2-col">
      <div class="column px-3">
        <label>Find options:</label>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="matchCase" (change)="onMatchCaseChanged($event)" />
          <label class="form-check-label" for="matchCase">Match case</label>
        </div>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="matchWholeWord"
            (change)="onMatchWholeWordChanged($event)" />
          <label class="form-check-label" for="matchWholeWord">Match whole word only</label>
        </div>
        <div class="form-group">
          <select
            class="form-select"
            aria-label="Search Direction"
            id="searchUpSelect"
            name="searchUpSelect"
            (change)="onSearchUpChanged($event)"
            [(ngModel)]="searchUp">
            <option selected value="up">Search Up</option>
            <option value="down">Search Down</option>
          </select>
        </div>
      </div>
      <div class="column px-3">
        <label>Search In:</label>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="checkbox-search-answers"
            name="checkbox-search-content"
            [(ngModel)]="txDocsSearchScope.answerFields" />
          <label class="form-check-label" for="checkbox-search-answers">Answers</label>
          <i
            class="bi bi-info-circle-fill m-3"
            triggers="mouseenter:mouseleave"
            container="body"
            placement="top"
            popoverTitle="Answers a light purple color."
            ngbPopover="Answers with a light purple background color like this."
            popoverClass="popover-answer-info"></i>
        </div>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="checkbox-search-calculatedFields"
            name="checkbox-search-calculatedFields"
            [(ngModel)]="txDocsSearchScope.calculatedFields" />
          <label class="form-check-label" for="checkbox-search-calculatedFields">Calculated Fields</label>
          <i
            class="bi bi-info-circle-fill m-3"
            triggers="mouseenter:mouseleave"
            container="body"
            placement="top"
            popoverTitle="Answers a silver color."
            ngbPopover="Answers of a silver background color like this."
            popoverClass="popover-calculated-info"></i>
        </div>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="checkbox-search-content"
            name="checkbox-search-content"
            container="body"
            [(ngModel)]="txDocsSearchScope.content" />
          <label class="form-check-label" for="checkbox-search-content">Document Text</label>
          <i
            class="bi bi-info-circle-fill m-3"
            triggers="mouseenter:mouseleave"
            popoverTitle="Normal document text"
            ngbPopover="Normal document text that is not an answer like this."
            container="body"
            placement="top"
            popoverClass="popover-text-info"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer py-2">
    <div *ngIf="activeTab == 'replace'" class="btn-group btn-group-sm">
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        (click)="this.onReplaceClicked()"
        [disabled]="txTextSelectionLength == 0">
        Replace
      </button>
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        (click)="this.onReplaceAllClicked()"
        [disabled]="
          searchQuery == '' ||
          txDocsSearchScope.answerFields ||
          txDocsSearchScope.calculatedFields ||
          searchSelectionInvalid ||
          txTextSelectionLength == 0
        ">
        Replace All
      </button>
    </div>
    <button
      #nextButton
      type="button"
      class="btn btn-primary btn-sm"
      (click)="this.onFindClicked()"
      [disabled]="
        searchQuery == '' ||
        (!txDocsSearchScope.content && !txDocsSearchScope.answerFields && !txDocsSearchScope.calculatedFields)
      ">
      Find Next
    </button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="onClose()">Close</button>
  </div>
</div>
